// Tremor Date Picker [v2.0.0]
"use client"
import * as React from "react"
import { DateRange } from "@react-aria/datepicker"
import { type Matcher } from "@/components/molecules/Calendar"
import { SingleDatePicker, SingleDatePickerProps, SingleProps } from "./SingleDatePicker"
import { validatePresets } from "./utils"
import { RangeDatePicker, RangeDatePickerProps, RangeProps } from "./RangeDatePicker"
import { Locale } from "date-fns"



export type CalendarProps = {
    fromYear?: number
    toYear?: number
    fromMonth?: Date
    toMonth?: Date
    fromDay?: Date
    toDay?: Date
    fromDate?: Date
    toDate?: Date
    locale?: Locale
}

export type Translations = {
    cancel?: string
    apply?: string
    start?: string
    end?: string
    range?: string
}

export interface PickerProps extends CalendarProps {
    className?: string
    disabled?: boolean
    disabledDays?: Matcher | Matcher[] | undefined
    required?: boolean
    showTimePicker?: boolean
    placeholder?: string
    enableYearNavigation?: boolean
    disableNavigation?: boolean
    hasError?: boolean
    id?: string
    // Customize the date picker for different languages.
    translations?: Translations
    align?: "center" | "end" | "start"
    "aria-invalid"?: boolean
    "aria-label"?: string
    "aria-labelledby"?: string
    "aria-required"?: boolean
}



const DatePicker = ({ presets, ...props }: SingleDatePickerProps) => {
    if (presets) {
        validatePresets(presets, props)
    }

    return <SingleDatePicker presets={presets} {...(props as SingleProps)} />
}

DatePicker.displayName = "DatePicker"


const DateRangePicker = ({ presets, ...props }: RangeDatePickerProps) => {
    if (presets) {
        validatePresets(presets, props)
    }

    return <RangeDatePicker presets={presets} {...(props as RangeProps)} />
}

DateRangePicker.displayName = "DateRangePicker"

export {
    DatePicker,
    DateRangePicker,
    type DateRange,
}